var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Close, Search } from '@mui/icons-material';
import { StyledTextField } from './SearchTextField.styles';
import IconButton from '../IconButton/IconButton';
const SearchTextField = (_a) => {
    var { onClear } = _a, props = __rest(_a, ["onClear"]);
    const hasValue = !!props.value;
    return (_jsx(StyledTextField, Object.assign({}, props, { InputProps: {
            startAdornment: _jsx(Search, { color: 'action' }),
            endAdornment: hasValue && onClear ? (_jsx(IconButton, { size: 'small', edge: 'end', onClick: onClear, children: _jsx(Close, {}) })) : null,
        } })));
};
export default SearchTextField;
